'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _withToggle = require('../with-toggle');

var _withToggle2 = _interopRequireDefault(_withToggle);

var _compose = require('../lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchForm = function (_Component) {
  _inherits(SearchForm, _Component);

  function SearchForm() {
    _classCallCheck(this, SearchForm);

    var _this = _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).call(this));

    _this.showForm = _this.showForm.bind(_this);
    _this.closeForm = _this.closeForm.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(SearchForm, [{
    key: 'showForm',
    value: function showForm() {
      this.props.onToggleOn();
      this.refs.field.focus();
    }
  }, {
    key: 'closeForm',
    value: function closeForm() {
      this.refs.field.value = '';
      this.props.onToggleOff();
      this.props.onChange();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.closeForm();
      }
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      var _this2 = this;

      var _props = this.props,
          debounce = _props.debounce,
          onChange = _props.onChange;


      return debounce ? this.debounce(onChange) : function () {
        return onChange(_this2.refs.field.value);
      };
    }
  }, {
    key: 'debounce',
    value: function debounce(callback) {
      var _this3 = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

      var timeout = void 0;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          callback(_this3.refs.field.value);
        }, delay);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          button = _props2.button,
          buttonText = _props2.buttonText,
          children = _props2.children,
          placeholder = _props2.placeholder,
          title = _props2.title,
          expanded = _props2.expanded,
          toggled = _props2.toggled,
          classNames = _props2.classNames,
          autofocus = _props2.autofocus;


      return _react2.default.createElement(
        'div',
        { className: 'c11n-search-form ' + classNames.root },
        _react2.default.createElement(
          'div',
          { className: classNames.form, onKeyDown: this.handleKeyDown },
          _react2.default.createElement(
            'label',
            { className: classNames.field, id: 'label-search-form' },
            _react2.default.createElement(
              'span',
              { className: classNames.label },
              title
            ),
            _react2.default.createElement('input', {
              ref: 'field',
              type: 'search',
              'aria-labelledby': 'label-search-form',
              placeholder: placeholder,
              autoFocus: autofocus,
              onFocus: this.showForm,
              onChange: this.onChange(),
              className: classNames.input
            })
          ),
          _react2.default.createElement(
            'div',
            { className: classNames.cta },
            _react2.default.createElement(_button2.default, _extends({
              onClick: expanded ? this.onChange() : toggled ? this.closeForm : this.showForm,
              children: expanded ? buttonText : toggled ? 'Close' : buttonText,
              'aria-label': expanded ? buttonText : toggled ? 'Close' : buttonText
            }, button))
          )
        ),
        children && _react2.default.createElement(
          'div',
          { className: classNames.results },
          children
        )
      );
    }
  }]);

  return SearchForm;
}(_react.Component);

SearchForm.propTypes = {
  /**
   * The onChange event handler to be fired
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The title for the section
   */
  title: _propTypes2.default.string,

  /**
   * The placeholder for the input
   */
  placeholder: _propTypes2.default.string,

  /**
   * The button text
   */
  buttonText: _propTypes2.default.string,

  /**
   * Autofocus the search input on form load (best for modals)
   */
  autofocus: _propTypes2.default.bool,

  /**
   * Disable toggle functionality (best for modals)
   */
  expanded: _propTypes2.default.bool,

  /**
   * Whether or note to debounce the onChange callback
   */
  debounce: _propTypes2.default.bool,

  /**
   * Custom styles for the component
   */
  styles: _propTypes2.default.object,

  /**
   * Props to be passed to the Button component
   */
  button: _propTypes2.default.object,

  /**
   * To be displayed under the field, usually SearchResult(s)
   */
  children: _propTypes2.default.any
};

SearchForm.defaultProps = {
  title: 'Looking for someone?',
  placeholder: 'Find a fundraiser',
  buttonText: 'Search',
  autofocus: false,
  expanded: false,
  debounce: true,
  onChange: function onChange() {}
};

exports.default = (0, _compose2.default)(_withToggle2.default, (0, _withStyles2.default)(_styles2.default))(SearchForm);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/search-form/index.js
// module id = 241
// module chunks = 0